// src/guestTrips/guestTripPresentation.ts
import { BookingStatus } from "@maat/api-booking/types";
var DAY_MS = 24 * 60 * 60 * 1e3;
var daysBetween = (from, to) => Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / DAY_MS);
var ahead = (days) => {
  if (days === 0) return { key: "today" };
  if (days === 1) return { key: "tomorrow" };
  if (days < 14) return { key: "inDays", count: days };
  if (days < 60) return { key: "inWeeks", count: Math.floor(days / 7) };
  return { key: "inMonths", count: Math.floor(days / 30) };
};
var behind = (days) => {
  if (days <= 0) return { key: "endedToday" };
  if (days < 14) return { key: "endedDays", count: days };
  if (days < 60) return { key: "endedWeeks", count: Math.floor(days / 7) };
  return { key: "endedMonths", count: Math.floor(days / 30) };
};
var guestTripChip = (trip, today) => {
  if (trip.status === BookingStatus.Cancelled || trip.status === BookingStatus.Rejected || trip.status === BookingStatus.NoShow) {
    return null;
  }
  if (trip.status === BookingStatus.CheckedIn) return { key: "stayingNow" };
  const untilStart = daysBetween(today, trip.check_in);
  if (untilStart >= 0 && trip.status !== BookingStatus.Completed) return ahead(untilStart);
  const lastDay = trip.nights > 0 ? trip.check_out : trip.check_in;
  const sinceEnd = daysBetween(lastDay, today);
  if (trip.status !== BookingStatus.Completed && sinceEnd < 0) return { key: "stayingNow" };
  return behind(sinceEnd);
};
var guestTripRefundLine = (trip) => {
  const refund = trip.refund_if_cancelled_now;
  if (!refund) return null;
  if (trip.status === BookingStatus.Pending) return { key: "withdrawFull" };
  if (refund.percent <= 0) return { key: "noneNow" };
  if (!refund.last_day) {
    return refund.percent >= 100 ? { key: "fullNow" } : { key: "partialNow", percent: refund.percent };
  }
  return refund.percent >= 100 ? { key: "fullUntil", lastDay: refund.last_day } : { key: "partialUntil", percent: refund.percent, lastDay: refund.last_day };
};
var guestTripActions = (trip) => trip.awaiting_review ? ["view", "review"] : ["view"];

export {
  guestTripChip,
  guestTripRefundLine,
  guestTripActions
};
